import { SkeletonDots } from '@yes.technology/react-toolkit'
import React from 'react'
import styled from 'styled-components'
import { Mode } from './hooks/useTableContext'

const TableHeaderColumnBlock = ({
  children,
  ...thProps
}: React.HTMLAttributes<HTMLTableCellElement>) => (
  <th {...thProps}>
    <span>{children}</span>
  </th>
)

export const TableHeaderColumn = styled(TableHeaderColumnBlock)<{
  mode: Mode
  width?: string
}>`
  white-space: nowrap;

  ${({ width }) => width && `width: ${width}; max-width: ${width};`}

  ${({ mode }) =>
    mode === 'view'
      ? `
    && {
      padding: 0.5rem 0;
    }

    &:first-of-type {
      padding-left: 0;
    }

    &:last-of-type {
      padding-right: 0;
    }

    > span {
      display: flex;
      position: relative;
      padding: 0 20px 0.5rem 0;
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 16px;
        height: 2px;
        background-color: #abbed1;
      }
    }

    &:last-of-type > span {
      margin-right: 0;

      &::after {
        right: 0;
      }
    }
  `
      : 'padding-bottom: 0 !important;'}
`

export const DataTableSkeletonDots = styled(SkeletonDots).attrs({ size: 3 })`
  height: 1em;
  align-items: flex-end;
  color: inherit;

  & > div {
    background-color: currentColor;
  }
`

export const AreaLineCenter = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: flex;
  }
`
export const Badge = styled.span`
  color: #0c1014;
  font-size: 14px;
  font-weight: 700;
`

export const SortButton = styled.button`
  background-color: transparent;
  border: 0;
  display: flex;
  align-items: center;
  gap: 2px;
  margin: 0;
  padding: 0 2px 0 0;
`
